import DataGridTableSkeleton from "../../../components/skeletons/DataGridTableSkeleton";

export default function CompanyListSkeleton() {
  return (
    <DataGridTableSkeleton height={500} rowCount={10} />
  );
}
